import { RawAvailabilityCalendar } from '@calendar';

function isDate(date: string): boolean {
  return /^\d{4}-\d{2}-\d{2}$/.test(date);
}

export class AvailabilityCalendar {
  checkin!: string;
  checkout!: string;
  data!: RawAvailabilityCalendar;

  constructor(data: undefined | any = undefined) {
    this.data = {};
    if (data) {
      for (const key in data) {
        if (!isDate(key)) continue;
        this.data[key] = data[key];
      }
    }
  }
}

export default AvailabilityCalendar;
